import { graphql } from "@/gql";

export const createWorkOrderMutation = graphql(`
  mutation CreateWorkOrderMutation($input: CreateWorkOrderInput!) {
    createWorkOrder(input: $input) {
      id
    }
  }
`);

export const updateWorkOrderMutation = graphql(`
  mutation UpdateWorkOrderMutation($id: ID!, $input: UpdateWorkOrderInput!) {
    updateWorkOrder(id: $id, input: $input) {
      id
    }
  }
`);

export const assignAdminToWorkOrderMutation = graphql(`
  mutation AssignAdminToWorkOrder($work_order_id: ID!, $user_id: ID!) {
    assignAdminToWorkOrder(work_order_id: $work_order_id, user_id: $user_id) {
      id
      adminAssignees {
        id
        name
      }
    }
  }
`);

export const invoiceWorkOrderMutation = graphql(`
  mutation InvoiceWorkOrderMutation($id: ID!) {
    invoiceWorkOrder(id: $id) {
      id
    }
  }
`);

export const archiveWorkOrderMutation = graphql(`
  mutation ArchiveWorkOrderMutation($id: ID!) {
    markWorkOrderAsArchived(id: $id) {
      id
    }
  }
`);

export const assignInvoiceToWorkOrderMutation = graphql(`
  mutation AssignInvoiceToWorkOrderMutation(
    $workOrderId: ID!
    $invoiceId: ID!
  ) {
    assignInvoiceToWorkOrder(workOrderId: $workOrderId, invoiceId: $invoiceId) {
      id
    }
  }
`);

export const setWorkOrderInvoiceNotRequiredMutation = graphql(`
  mutation SetWorkOrderInvoiceNotRequiredMutation(
    $id: ID!
    $invoice_not_required: Boolean!
  ) {
    setWorkOrderInvoiceNotRequired(
      id: $id
      invoice_not_required: $invoice_not_required
    ) {
      id
      invoice_not_required
    }
  }
`);

export const generateWorkOrderManifestPdfMutation = graphql(`
  mutation GenerateWorkOrderManifestPdfMutation($id: ID!) {
    generateWorkOrderManifestPdf(id: $id) {
      id
      url
    }
  }
`);
